import React from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { AccountAccess } from '../components/account-access.component';
import { Footer } from '../components/footer.component';
import LoyaltyProgramComponent from '../components/loyalty-program.component';
import SectionHeader from '../components/common';
import SEOMetadataComponent from '../components/seo-metadata.component';
import { LOCALES } from '../../common/constants';
import { getSchemaMarkup } from "../../common/FunctionUtils";
import '../scss/main.scss';
import { Sidebar } from '../components/Sidebar/index';
import Header from '../components/header/Header';

export const LoyaltyProgramPage: React.FC = () => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;
    const isEnglish = currentLanguage === 'en' || currentLanguage === LOCALES.EN_US;
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

    // Dynamic canonical URL based on language
    const canonicalUrl = isEnglish
        ? `https://www.invozio.com/loyalty-program?lang=${LOCALES.EN_US}`
        : `https://www.invozio.com/loyalty-program?lang=${LOCALES.SV_SE}`;

    const schemaMarkup = getSchemaMarkup("loyalty-program");

    return (
        <>
            {/* <SEOMetadataComponent
                title={t('LOYALTY_PROGRAM_TITLE')}
                description={t('LOYALTY_PROGRAM_SUBTITLE')}
                canonicalUrl={canonicalUrl}
                noindex={false}
                robots="index, follow"
                schemaMarkup={schemaMarkup}
            /> */}
            {/* <Container fluid className="px-0"> */}
            <div className="dashboard-page">
                <div className="dashboard-layout">
                    <Sidebar
                        activeItemId="loyalty-program"
                        footer={null}
                        onClose={() => setIsSidebarOpen(false)}
                        className={`dashboard-sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}
                    />
                    <div className="dashboard-main-content">
                        <Header
                        setIsSidebarOpen={setIsSidebarOpen}
                        />
                        <LoyaltyProgramComponent />
                    </div>
                </div>
            </div>

        </>
    );
};

export default LoyaltyProgramPage;
